<template>
  <v-container fluid grid-list-md py1>
    <v-layout row wrap>
      <!-- Datos del usuario -->
      <v-flex lg4 md5 sm12 xs12>
        <v-card>
          <v-card-text class="text-center">
            <form>
              <v-layout row wrap>
                <v-flex xs12 class="croppa_flex">
                  <br />
                  <croppa
                    v-model="croppa"
                    :new-image-drawn="renderImage()"
                    :zoom-speed="3"
                    class="userdp"
                    :width="150"
                    :height="150"
                    :placeholder="$t('view.commons.imgsel')"
                    placeholder-color="#000"
                    :placeholder-font-size="10"
                    canvas-color="transparent"
                    :show-loading="true"
                    :loading-size="25"
                    loading-color="#606060"
                    initial-position="center"
                    initial-size="cover"
                    :show-remove-button="false"
                    :prevent-white-space="true"
                    @move="renderImageChange"
                    @zoom="renderImageChange" />
                  <v-btn
                    v-if="perfilUsuario.foto"
                    fab
                    outlined
                    width="30"
                    height="30"
                    color="primary"
                    class="btn_tippy ml-2"
                    elevation="0"
                    :title="$t('view.commons.imgrem')"
                    @click="croppaRemove()">
                    <em class="fas fa-times" />
                  </v-btn>
                </v-flex>

                <v-flex xs12>
                  <h3 id="h3username" class="mb-2" style="font-size: 23px">
                    {{ perfilUsuarioLoadedData.nombre }}
                  </h3>
                </v-flex>

                <v-flex xs12 style="font-size: 16px" class="mb-2">
                  {{ perfilUsuario.username }}
                </v-flex>

                <v-flex xs12 style="font-size: 15px" class="mb-2">
                  <em class="fas fa-envelope" /> <strong>{{ perfilUsuarioLoadedData.correoElectronico }}</strong>
                </v-flex>

                <v-flex xs12 style="font-size: 15px">
                  <v-layout row wrap>
                    <v-flex xs12 style="font-weight: bold">
                      {{ $t("view.seguridad.perfilUsuario.perfiles.label") }}
                    </v-flex>
                    <v-flex xs12>
                      {{ getGroups }}
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm6 style="font-size: 15px">
                  <v-layout row wrap>
                    <v-flex xs12 style="font-weight: bold">
                      {{ $t("view.seguridad.perfilUsuario.telefono.label") }}
                    </v-flex>
                    <v-flex xs12>
                      {{ perfilUsuarioLoadedData.telefono }}
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm6 style="font-size: 15px">
                  <v-layout row wrap>
                    <v-flex xs12 style="font-weight: bold">
                      {{ $t("view.seguridad.perfilUsuario.interno.label") }}
                    </v-flex>
                    <v-flex xs12>
                      {{ perfilUsuarioLoadedData.interno }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </form>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-flex shrink>
              <v-btn
                v-show="$userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')"
                id="btnsubmit"
                fab
                small
                color="primary"
                class="btn_tippy"
                elevation="0"
                :title="$t('view.commons.update')"
                :disabled="form.$state.isDisableButtonSubmit() || perfilUsuario.foto == ''"
                :loading="view.action.submit.busy"
                @click="submit()">
                <v-icon small>button__icon icon fas fa-check</v-icon>
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>

      <!-- Linea de tiempo de cambio de pass -->
      <v-flex id="vertical-timeline" md6 xs12 class="vertical-container light-timeline center-orientation vertical-timeline-top-off">
        <div class="vertical-timeline-block">
          <div class="vertical-timeline-icon timeline-circle-orange">
            <em class="fas fa-unlock" />
          </div>
          <div class="vertical-timeline-content">
            <h4>{{ $t("view.seguridad.perfilUsuario.ultimoCambioContrasena.label") }}</h4>
            <p>{{ getUltimoCambio }}</p>
          </div>
        </div>
        <div class="vertical-timeline-block">
          <div class="vertical-timeline-icon timeline-circle-orange">
            <em class="far fa-clock" />
          </div>
          <div class="vertical-timeline-content">
            <h4 style="margin-top: 0px !important; margin-bottom: 0px !important">
              {{ $t("view.seguridad.perfilUsuario.tiempoRestante.label") }}
            </h4>
            <p>{{ userData.diasVencimiento }} Días</p>
          </div>
        </div>
        <div class="vertical-timeline-block">
          <div class="vertical-timeline-icon timeline-circle-orange">
            <em class="fas fa-lock" />
          </div>
          <div class="vertical-timeline-content">
            <h4 style="margin-top: 0px !important; margin-bottom: 0px !important">
              {{ $t("view.seguridad.perfilUsuario.proximoCambioContrasena.label") }}
            </h4>
            <p>{{ getProximoCambio }}</p>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PerfilUsuarioAPI from "@/services/seguridad/perfilUsuario"; /** *******************************/
import perfilusuarioStates from "@/views/seguridad/perfilUsuario/perfilUsuario-state"; /** *******************************/
import { handleResponse } from "@/helpers/http-response-handler";
import { formatDate } from "@/helpers/date-methods";
import { required } from "vuelidate/lib/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { isNotEmpty } from "@/helpers/validators";
import tippy from "tippy.js";

const section = { form: { visible: true } };

const action = { submit: { busy: false } };

const croppa = {};

export default {
  name: "PerfilUsuario"
  , data() {
    return {
      perfilUsuario: undefined
      , perfilUsuarioLoadedData: []
      , state: new Object()
      , form: new Object()
      , view: {
        title: this.$t("view.seguridad.perfilUsuario.title")
        , action
        , elem: { button: { removeImg: { visible: false } } }
        , section
      }
      , check: true
      , croppa
      , croppainput: false
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , computed: {
    userData() {
      return this.$store.getters.getUserData ? this.$store.getters.getUserData : [];
    }
    , getUltimoCambio() {
      return this.userData ? formatDate(this.userData.ultimaModificacionPassword) : "";
    }
    , getProximoCambio() {
      return this.userData ? formatDate(this.userData.fechaVencimiento) : "";
    }
    , getGroups() {
      return this.userData.grupos ? this.userData.grupos.join(", ") : "";
    }
    , fotoPerfil() {
      return isNotEmpty(this.userData.fotoPerfil) ? this.userData.fotoPerfil : "/static/img/user_thumbnail.jpg";
    }
  }
  , created() {
    this.form = new perfilusuarioStates(this);
    this.form.$setState("initial");
    this.loadperfilusuario();
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.perfilUsuario);
        if (handleResponse(respuesta, this.$t("view.seguridad.perfilUsuario.errors"))) {
          const { data: { results: { usuario } } } = respuesta;
          this.form.$setState("editing", usuario);
        }
      } catch (error) {
        handleResponse(error, this.$t("view.seguridad.perfilUsuario.errors"));
      }
    }
    , async loadperfilusuario() {
      try {
        let username = this.userData.username;
        const response = await PerfilUsuarioAPI.get({ username });
        if (response != null) {
          const { data: { results: { usuario } } } = response;
          this.perfilUsuarioLoadedData = usuario;
          this.form.$setState("editing", usuario);
        }
      } catch (error) {
        console.log(error);
      }
    }
    , renderImage() {
      if (this.croppainput && this.croppa && this.croppa.hasImage) {
        this.perfilUsuario.foto = this.croppa.generateDataUrl();
        this.perfilUsuario.fotoMiniatura = this.croppa.generateDataUrl("image/jpeg", 0.5);
        this.croppainput = this.perfilUsuario.foto.length == 0;
      }
    }
    , renderImageChange() {
      if (this.croppa && this.croppa.hasImage) {
        this.perfilUsuario.foto = this.croppa.generateDataUrl();
        this.perfilUsuario.fotoMiniatura = this.croppa.generateDataUrl("image/jpeg", 0.5);
      }
    }
    , croppaRemove() {
      this.perfilUsuario.foto = "";
      this.perfilUsuario.fotoMiniatura = "";
      this.view.elem.button.removeImg.visible = false;
      this.croppa.remove();
      this.croppainput = true;
      setTimeout(() => document.body.click(), 100);
    }
  }
  , validations: {
    perfilUsuario: {
      foto: { required }
      , username: { required }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #000;
}
.croppa_flex {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 30px !important;
}
.userdp {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden;
}
.contact-box.center-version > a img {
  width: 100% !important;
  height: 100% !important;
  margin-top: 10px;
  margin-bottom: 10px;
}
/* New Timeline style */
.vertical-container {
  width: 90%;
  max-width: 1170px;
  margin: 0 auto;
}
.vertical-container::after {
  content: "";
  display: table;
  clear: both;
}
#vertical-timeline {
  position: relative;
  padding: 0;
  margin-top: 2em;
  margin-bottom: 2em;
  margin-left: 3%;
  width: 50%;
  margin-right: 3%;
}
#vertical-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 18px;
  height: 100%;
  width: 4px;
  background: #f1f1f1;
}
.vertical-timeline-content .btn {
  float: right;
}
#vertical-timeline.light-timeline:before {
  background: #e7eaec;
}
@media only screen and (min-width: 1170px) {
  #vertical-timeline.center-orientation {
    margin-top: 3em;
    margin-bottom: 3em;
  }
  #vertical-timeline.center-orientation:before {
    left: 50%;
    margin-left: -2px;
  }
}
.vertical-timeline-block {
  position: relative;
  margin: 2em 0;
}
.vertical-timeline-block:after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline-block:first-child {
  margin-top: 0;
}
.vertical-timeline-block:last-child {
  margin-bottom: 0;
}
@media only screen and (min-width: 1170px) {
  .center-orientation .vertical-timeline-block {
    margin: 4em 0;
  }
  .center-orientation .vertical-timeline-block:first-child {
    margin-top: 0;
  }
  .center-orientation .vertical-timeline-block:last-child {
    margin-bottom: 0;
  }
}
.vertical-timeline-icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 16px;
  border: 3px solid #f1f1f1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (min-width: 1170px) {
  .center-orientation .vertical-timeline-icon {
    width: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    font-size: 19px;
  }
  .center-orientation .vertical-timeline-icon i {
    margin-left: -12px;
    margin-top: -10px;
  }
  .center-orientation .cssanimations .vertical-timeline-icon.is-hidden {
    visibility: hidden;
  }
}
.vertical-timeline-content {
  position: relative;
  margin-left: 90px;
  background: white;
  border-radius: 0.25em;
  padding: 1em;
  height: 125px;
}
.vertical-timeline-content:after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline-content h2 {
  font-weight: 400;
  margin-top: 4px;
}
.vertical-timeline-content p {
  margin: 1em 0;
  line-height: 1.6;
}
.vertical-timeline-content .vertical-date {
  float: left;
  font-weight: 500;
}
.vertical-date small {
  color: #1ab394;
  font-weight: 400;
}
.vertical-timeline-content::before {
  content: "";
  position: absolute;
  top: 16px;
  right: 100%;
  height: 0;
  width: 0;
  border: 18px solid transparent;
  border-right: 7px solid white;
}
@media only screen and (min-width: 768px) {
  .vertical-timeline-content h2 {
    font-size: 18px;
  }
  .vertical-timeline-content p {
    font-size: 13px;
  }
}

@media only screen and (min-width: 1170px) {
  .center-orientation .vertical-timeline-content {
    margin-left: 0;
    padding: 1.6em;
    width: 35%;
    border: 1px solid #e7eaec;
  }
  .center-orientation .vertical-timeline-content::before {
    top: 24px;
    left: 100%;
    border-color: transparent;
    border-left: 20px solid gray;
  }
  .center-orientation .vertical-timeline-content .btn {
    float: left;
  }
  .center-orientation .vertical-timeline-content .vertical-date {
    position: absolute;
    width: 100%;
    left: 122%;
    top: 2px;
    font-size: 14px;
  }
  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content {
    float: right;
  }
  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content::before {
    top: 24px;
    left: auto;
    right: 100%;
    border-color: transparent;
    border-right: 20px solid gray;
  }
  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content .btn {
    float: right;
  }
  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content .vertical-date {
    left: auto;
    right: 122%;
    text-align: right;
  }
  .center-orientation .cssanimations .vertical-timeline-content.is-hidden {
    visibility: hidden;
  }
}

/**
* Custom timeline
*/

.timeline-circle-orange {
  background-color: var(--primary);
  color: #ffffff;
  width: 54px;
  height: 54px;
}

.custom-timeline-widget-top h2 {
  font-size: 14px;
  font-weight: 400;
}

.custom-timeline-widget-top p {
  font-size: 12px;
  font-weight: 400;
}

.custom-timeline-widget h4 {
  font-size: 14px;
  font-weight: 400;
  margin: 0 0 0px !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.custom-timeline-widget p {
  font-size: 12px;
  font-weight: 400;
}

.custom-timeline-widget-top {
  background-color: #ffffff;
  color: #000;
  padding-left: 17px;
  padding-right: 17px;
  padding-bottom: 15px;
  padding-top: 5px;
  height: 125px;
  max-height: 150px;
  margin-bottom: 25px;
  margin-top: 225px;
  border: 1px solid #e7eaec;
  border-radius: 5%;
}

.custom-timeline-widget-top::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -8.666%;
  height: 0;
  width: 0;
  border: 20px solid transparent;
  border-bottom: 18px solid #676a6c;
}

.custom-timeline-widget {
  background-color: #ffffff;
  color: #000;
  padding-left: 17px;
  padding-right: 17px;
  padding-bottom: 15px;
  padding-top: 5px;
  height: 125px;
  max-height: 150px;
  margin-bottom: 25px;
  border: 1px solid #e7eaec;
  border-radius: 5%;
}

.custom-timeline-widget::before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -8.666%;
  height: 0;
  width: 0;
  border: 20px solid transparent;
  border-top: 18px solid #676a6c;
}

#custom-timeline {
  position: relative;
  padding: 0;
  margin-top: 2em;
  margin-bottom: 2em;
}

#custom-timeline::before {
  content: "";
  position: absolute;
  top: 46%;
  left: 10%;
  right: 12%;
  height: 3px;
  width: 70%;
  background: #e7eaec;
}

.custom-timeline-icon-top {
  position: absolute;
  left: 50%;
  margin-left: -10.666%;
  top: 119%;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  font-size: 16px;
  border: 3px solid #f1f1f1;
  text-align: center;
}

.custom-timeline-icon-top i {
  display: block;
  width: 24px;
  height: 24px;
  position: relative;
  left: 50%;
  top: 50%;
  margin-left: -12px;
  margin-top: -9px;
}

.custom-timeline-icon-bottom {
  position: absolute;
  left: 50%;
  margin-left: -11.2%;
  bottom: 120%;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  font-size: 16px;
  border: 3px solid #f1f1f1;
  text-align: center;
}

.custom-timeline-icon-bottom i {
  display: block;
  width: 24px;
  height: 24px;
  position: relative;
  left: 50%;
  top: 50%;
  margin-left: -12px;
  margin-top: -9px;
}

/**
*   MOBILE TABLET CUSTOM TIMELINE
**/
@media (max-width: 767px) {
  .custom-timeline-widget-top {
    background-color: #ffffff;
    color: #000;
    padding-left: 17px;
    padding-right: 17px;
    padding-bottom: 15px;
    padding-top: 5px;
    height: 105px;
    width: 55%;
    max-height: 200px;
    margin-bottom: 50px;
    margin-top: 0px;
    border: 1px solid #e7eaec;
    border-radius: 5%;
    left: 30%;
  }

  .custom-timeline-widget-top::before {
    content: "";
    position: absolute;
    bottom: 50%;
    left: 0;
    right: 0;
    margin-left: -38px;
    top: 32px;
    height: 0;
    width: 0;
    border: 20px solid transparent;
    border-right: 18px solid #676a6c;
  }

  .custom-timeline-widget {
    background-color: #ffffff;
    color: #000;
    padding-left: 17px;
    padding-right: 17px;
    padding-bottom: 15px;
    padding-top: 5px;
    height: 105px;
    width: 55%;
    max-height: 200px;
    margin-bottom: 50px;
    border: 1px solid #e7eaec;
    border-radius: 5%;
    left: 30%;
  }

  .custom-timeline-widget::before {
    content: "";
    position: absolute;
    bottom: 50%;
    left: 0;
    right: 0;
    margin-left: -38px;
    top: 32px;
    height: 0;
    width: 0;
    border: 20px solid transparent;
    border-right: 18px solid #676a6c;
  }

  #custom-timeline {
    position: relative;
    padding: 0;
    margin-top: 2em;
    margin-bottom: 2em;
  }

  #custom-timeline::before {
    content: "";
    position: absolute;
    top: 60px;
    bottom: 1%;
    left: 15px;
    right: 12%;
    height: 315px;
    width: 3px;
    background: #e7eaec;
  }

  .custom-timeline-icon-top {
    position: absolute;
    left: -44%;
    margin-left: -15%;
    top: 30%;
    width: 54px;
    height: 54px;
    border-radius: 50%;
    font-size: 16px;
    border: 3px solid #f1f1f1;
    text-align: center;
  }

  .custom-timeline-icon-top i {
    display: block;
    width: 24px;
    height: 24px;
    position: relative;
    left: 50%;
    top: 50%;
    margin-left: -12px;
    margin-top: -9px;
  }

  .custom-timeline-icon-bottom {
    position: absolute;
    left: -44%;
    margin-left: -15%;
    bottom: 22%;
    width: 54px;
    height: 54px;
    border-radius: 50%;
    font-size: 16px;
    border: 3px solid #f1f1f1;
    text-align: center;
  }

  .custom-timeline-icon-bottom i {
    display: block;
    width: 24px;
    height: 24px;
    position: relative;
    left: 50%;
    top: 50%;
    margin-left: -12px;
    margin-top: -9px;
  }
}

body.rtls .center-orientation .vertical-timeline-icon i {
  margin-left: 0;
  margin-right: -12px;
}
body.rtls .vertical-timeline-icon i {
  right: 50%;
  left: auto;
  margin-left: auto;
  margin-right: -12px;
}

@media (min-width: 767px) {
  .vertical-timeline-icon {
    margin-top: 18px;
  }
  #vertical-timeline {
    margin-top: 5px !important;
  }
  #vertical-timeline::before {
    margin-top: 20px;
    height: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/seguridad/perfilUsuario/PerfilUsuario.vue